export const themeColor = {
	primaryColor: "#60b044"
};

export const THEME_COLOR = themeColor;
